import { Form } from '@bancobarigui/barihaus';

import { useBankUserRegister } from './useBankUserRegister';
import { ProtectedRouteContainer } from '@/components/ProtectedRouteContainer';
import { PageHeader } from '@/components/PageHeader';
import { LoadingOverlay } from '@/components/LoadingOverlay';
import { ServiceCheck, FeatureAlert } from '@/shared/components';

import { BankUserForm } from './BankUserForm';
import { RegisterFormButtons } from '@/components/RegisterFormButtons';

function BankUserRegisterContent() {
  const { onSubmit, isSubmitting } = useBankUserRegister();

  return (
    <>
      <LoadingOverlay visible={isSubmitting} tip="Cadastrando usuário..." />

      <Form name="basic" onFinish={onSubmit} className="space-y-8 flex flex-col">
        <BankUserForm />

        <RegisterFormButtons onClickCancel={() => {}} loading={isSubmitting} />
      </Form>
    </>
  );
}

export default function BankUserRegister() {
  return (
    <ProtectedRouteContainer
      pageHeader={<PageHeader title="Cadastrar novo usuário - Módulo Banco" />}
    >
      <FeatureAlert services={['user']} />
      <ServiceCheck services={['user']} featureName="Cadastro de Usuario">
        <BankUserRegisterContent />
      </ServiceCheck>
    </ProtectedRouteContainer>
  );
}
